const BREAKPOINT_DESKTOP = "xl";
const BREAKPOINT_TABLET = "md";
const MEDIA_DESKTOP = `@media $${BREAKPOINT_DESKTOP}}`;
const MEDIA_TABLET = `@media $${BREAKPOINT_TABLET}`;
export {
  BREAKPOINT_DESKTOP,
  BREAKPOINT_TABLET,
  MEDIA_DESKTOP,
  MEDIA_TABLET
};
